import React, { useState, useEffect } from "react";
import { FaFilePdf, FaFileCode, FaFileImage, FaDownload, FaTimes, FaFolder } from "react-icons/fa";
import "./ResursModal.css";

function ResursModal({ resources, onClose }) {
    const [isClosing, setIsClosing] = useState(false);

    useEffect(() => {
        if (resources && resources.length > 0) {
            setIsClosing(false);
        }
    }, [resources]);

    if (!isClosing && (!resources || resources.length === 0)) return null;

    const categories = [
        { id: 'hujjat', nomi: 'Hujjatlar', types: ['pdf', 'document'], icon: <FaFilePdf /> },
        { id: 'kod', nomi: 'Kodlar', types: ['html', 'js', 'code', 'zip', 'css'], icon: <FaFileCode /> },
        { id: 'rasm', nomi: 'Rasmlar', types: ['image', 'jpg', 'png', 'svg'], icon: <FaFileImage /> },
        { id: 'boshqa', nomi: 'Boshqalar', types: [], icon: <FaFolder /> }
    ];

    const getIcon = (type) => {
        switch (type.toLowerCase()) {
            case 'pdf':
            case 'document':
                return <FaFilePdf />;
            case 'html':
            case 'code':
            case 'js':
            case 'css':
                return <FaFileCode />;
            case 'image':
            case 'jpg':
            case 'png':
            case 'svg':
                return <FaFileImage />;
            default:
                return <FaFolder />;
        }
    };

    // Group resources by category
    const groupedResources = categories.map(cat => {
        const items = resources.filter(res => {
            if (cat.id === 'boshqa') {
                return !categories.slice(0, 3).some(c => c.types.includes(res.turi.toLowerCase()));
            }
            return cat.types.includes(res.turi.toLowerCase());
        });
        return { ...cat, items };
    }).filter(cat => cat.items.length > 0);

    const handleClose = () => {
        setIsClosing(true);
        setTimeout(() => {
            onClose();
            setIsClosing(false);
        }, 300);
    };

    return (
        <div className={`resurs-modal-overlay ${isClosing ? 'modal-overlay-fade-out' : 'modal-overlay-fade-in'}`}>
            <div className={`resurs-modal-card ${isClosing ? 'modal-content-pop-out' : 'modal-content-pop-in'}`}>
                <div className="resurs-header">
                    <h3>Dars Resurslari</h3>
                    <button className="close-resurs-btn" onClick={handleClose}>
                        <FaTimes />
                    </button>
                </div>
                <div className="resurs-body">
                    {groupedResources.map((group) => (
                        <div key={group.id} className="resurs-category-section">
                            <h4 className="category-title">
                                {group.icon} {group.nomi}
                            </h4>
                            <ul className="resurs-list">
                                {group.items.map((res, index) => (
                                    <li key={index} className="resurs-item">
                                        <div className="resurs-icon-box">
                                            {getIcon(res.turi)}
                                        </div>
                                        <div className="resurs-info">
                                            <span className="resurs-name">{res.nomi}</span>
                                            <div className="resurs-meta">
                                                <span>{res.turi.toUpperCase()}</span>
                                                <span>•</span>
                                                <span>{res.hajmi}</span>
                                            </div>
                                        </div>
                                        <a
                                            href={res.manzil}
                                            download={res.nomi}
                                            className="download-icon-btn"
                                            title="Yuklab olish"
                                        >
                                            <FaDownload />
                                        </a>
                                    </li>
                                ))}
                            </ul>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
}

export default ResursModal;
